export const environment = {
  production: false,
  env: 'dev',
  apiBaseUrl: '/api/log/v3',
  apiBaseUrlV2: '/api/log/v2',
  reprocessBaseUrl: '/api/reprocess',
  // RHSSO Authorization Code + PKCE (login de usuário)
  iamLoginUrl: 'https://dev-iam.sascar.com.br/auth/realms/backoffice/protocol/openid-connect/auth',
  iamClientId: 'dev-int-monitor-integrations',
  iamRedirectUri: 'https://dev-protheus-integrations-monitor.app.sascar.com.br/iam/login',
  rhssoEnabled: true
};